import { render, staticRenderFns } from "./ExportAsDropdown.vue?vue&type=template&id=89315da4"
import script from "./ExportAsDropdown.vue?vue&type=script&lang=js"
export * from "./ExportAsDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports